export enum BlueReportType {
    DISTRICT,
    SCHOOL,
    CLASS,
    PLACE
}
